module.exports = __webpack_public_path__ + "medicine.1QzNGYqC.svg";